import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../shared/snackbar/snackbar.component';

@Injectable({
    providedIn: 'root',
})
export class SnackbarService {
    private readonly snackBar = inject(MatSnackBar);

    successSnackbar(message: string): void {
        this.snackBar.openFromComponent(SnackbarComponent, {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            duration: 3000,
            data: {
                message,
                type: 'success',
            },
            panelClass: 'snackbar-custom',
        });
    }

    errorSnackbar(message: string): void {
        this.snackBar.openFromComponent(SnackbarComponent, {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            duration: 3000,
            data: {
                message,
                type: 'error',
            },
            panelClass: 'snackbar-custom',
        });
    }

    warningSnackbar(message: string, duration = 7000): void {
        this.snackBar.openFromComponent(SnackbarComponent, {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            duration,
            data: {
                message,
                type: 'warning',
            },
            panelClass: 'snackbar-custom',
        });
    }
}
